export default {
  No: 'rgb(248, 43, 96)',
  Yes: 'rgb(32, 201, 51)',
  'Ongoing trial': 'rgb(119, 209, 243)',
  'Trial complete, no results reported yet': 'rgb(194, 245, 233)',
  'Ongoing trial, interim results reported': 'rgb(11, 118, 183)',
}
